import { Routes } from '@angular/router';
import { AuthGuard } from './auth.guard';
import { MenuComponent } from './pages/menu/menu.component';
import { HomeComponent } from './pages/home/home.component';

export const routes: Routes = [

  { path: 'login', loadComponent: () => import('./pages/login/login.component').then(m => m.LoginComponent) },
  { path: 'register', loadComponent: () => import('./pages/register/register.component').then(m => m.RegisterComponent) },
  { path: 'verify-account', loadComponent: () => import('./pages/verify-account/verify-account.component').then(m => m.VerifyAccountComponent) },

  { path: 'bind-summary/:id', loadComponent: () => import('./pages/bind-summary/bind-summary.component').then(m => m.BindSummaryComponent) },
  { path: 'bind-summary/:id/:type', loadComponent: () => import('./pages/bind-summary/bind-summary.component').then(m => m.BindSummaryComponent) },

  { path: 'nbi-summary/:id', loadComponent: () => import('./pages/nbi-summary/nbi-summary.component').then(m => m.NbiSummaryComponent) },
  { path: 'nbi-summary/:id/:type', loadComponent: () => import('./pages/nbi-summary/nbi-summary.component').then(m => m.NbiSummaryComponent) },

  { path: 'quote-summary/:id', loadComponent: () => import('./pages/quote-summary/quote-summary.component').then(m => m.QuoteSummaryComponent) },
  { path: 'quote-summary/:id/:type', loadComponent: () => import('./pages/quote-summary/quote-summary.component').then(m => m.QuoteSummaryComponent) },

  { path: 'client-invoice/:id', loadComponent: () => import('./pages/client-invoice/client-invoice.component').then(m => m.ClientInvoiceComponent) },
  { path: 'client-invoice/:id/:type', loadComponent: () => import('./pages/client-invoice/client-invoice.component').then(m => m.ClientInvoiceComponent) },

  { path: 'quote-referral/:id/:id2', loadComponent: () => import('./pages/quote-referrel/quote-referrel.component').then(m => m.QuoteReferrelComponent) },
  { path: 'quote-referral/:id/:id2/:type', loadComponent: () => import('./pages/quote-referrel/quote-referrel.component').then(m => m.QuoteReferrelComponent) },

  { path: '', redirectTo: 'login', pathMatch: 'full' },

  {
    path: '',
    component: MenuComponent,
    canActivate: [AuthGuard],
    children: [

      { path: 'home', component: HomeComponent },

      { path: 'search', loadComponent: () => import('./pages/search/search.component').then(m => m.SearchComponent) },

      { path: 'new-request', loadComponent: () => import('./pages/new-request/new-request.component').then(m => m.NewRequestComponent) },

      { path: 'edit-request', loadComponent: () => import('./pages/edit-request/edit-request.component').then(m => m.EditRequestComponent) },

      { path: 'non-binding-indication', loadComponent: () => import('./pages/non-binding-indication/non-binding-indication.component').then(m => m.NonBindingIndicationComponent) },

      { path: 'firm-quotes', loadComponent: () => import('./pages/quotes/quotes.component').then(m => m.QuotesComponent) },

      { path: 'bind-quote', loadComponent: () => import('./pages/bind-quotes/bind-quotes.component').then(m => m.BindQuotesComponent) },

      { path: 'match-structure', loadComponent: () => import('./pages/match-structure/match-structure.component').then(m => m.MatchStructureComponent) },

      { path: 'historic-events', loadComponent: () => import('./pages/historic-events-data/historic-events-data.component').then(m => m.HistoricEventsDataComponent) },

      { path: 'client-details/:type', loadComponent: () => import('./pages/client-details/client-details.component').then(m => m.ClientDetailsComponent) },

      { path: 'client-details/view/:type/:id', loadComponent: () => import('./pages/client-details/client-details.component').then(m => m.ClientDetailsComponent) },

      { path: 'client-details/edit/:type/:id', loadComponent: () => import('./pages/client-details/client-details.component').then(m => m.ClientDetailsComponent) },

      { path: 'clients', loadComponent: () => import('./pages/clients/clients.component').then(m => m.ClientsComponent) },

      { path: 'settings', loadComponent: () => import('./pages/settings/settings.component').then(m => m.SettingsComponent) },

      { path: 'create-version', loadComponent: () => import('./pages/create-version/create-version.component').then(m => m.CreateVersionComponent) },

      { path: '**', redirectTo: 'search' }

    ]
  }
];